import React from 'react';
import withBlockExtensions from '@plone/volto/helpers/Extensions/withBlockExtensions';
import { WrappedCardIcon } from '@ifpb/portal/components/CardIcon/CardIcon';
import type { CardBlockData } from './index';
import cx from 'classnames';

interface CardBlockViewProps {
  data: CardBlockData;
  className?: string;
  isEditMode?: boolean;
  style?: React.CSSProperties;
}

const getCardLink = (data: CardBlockData): string | undefined => {
  if (data.href?.length === 1) {
    return data.href[0]?.['@id'];
  }
  return data.external_link;
};

const CardBlockView: React.FC<CardBlockViewProps> = ({
  data,
  className,
  style,
  isEditMode,
}) => {
  const link = getCardLink(data);
  const theme = data.styles?.theme || 'default';

  return (
    <div
      className={cx('card-block', `card-theme-${theme}`, className)}
      style={style}
    >
      <WrappedCardIcon
        link={link}
        icon={data.icon_selector}
        title={data.text}
        openLinkInNewPage={data.openLinkInNewPage}
        isEditMode={isEditMode}
      />
    </div>
  );
};

export default withBlockExtensions(CardBlockView);
